import { render } from "./LiteScroller.vue?vue&type=template&id=4abfa726&scoped=true"
import script from "./LiteScroller.vue?vue&type=script&lang=js"
export * from "./LiteScroller.vue?vue&type=script&lang=js"

import "./LiteScroller.vue?vue&type=style&index=0&id=4abfa726&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4abfa726"

export default script